import React, { useRef, useState } from "react";
import {
  ClickAwayListener,
  Divider,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import { ToolBarMenu } from "Constants/ToolBarMenu";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  GET_BACK_FROM_DESIGN,
  SHOW_PROJECTS,
  UNIT_INFO,
} from "Stores/actionTypes";
import * as Icons from "react-bootstrap-icons";

export default function DesignToolbarMenu({ rtlLayout, setReload }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleClose = (event) => {
    if (
      event &&
      anchorRef.current &&
      anchorRef.current.contains(event.target)
    ) {
      return;
    }
    setOpen(false);
  };

  const gotoProject = (URL, reload = true) => {
    if (!reload) {
      dispatch({
        type: SHOW_PROJECTS,
        value: false,
      });
    }
    setReload(reload);
    dispatch({
      type: GET_BACK_FROM_DESIGN,
      mode: reload ? 1 : 3,
      address: URL,
    });
    dispatch({
      type: UNIT_INFO,
      unitInfo: null,
    });
    handleClose();
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <div className={`backMenu rtl-${rtlLayout}`}>
      <MuiButton
        ref={anchorRef}
        className="toolbar-menu"
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        title={t("backMenu")}
        innerIcon={open ? <Icons.ChevronUp /> : <Icons.ChevronDown />}
        size={"large"}
        variant="contained"
      />
      <Popper
        className="_toolbarMenu profileMenu"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        disablePortal
      >
        <Paper className="no-padding">
          <ClickAwayListener onClickAway={handleClose}>
            <MenuList
              autoFocusItem={open}
              id="menu-list-grow"
              onKeyDown={handleListKeyDown}
            >
              {ToolBarMenu.design
                .filter((items) => items.authorize)
                .filter((items) => !items.disabled)
                .map((items) => {
                  return (
                    <div
                      key={`design-${items.menu_title}-${items.path || items.action || "item"}`}
                      style={{ width: "100%" }}
                    >
                      {items.needUpDivider && <Divider />}
                      <MenuItem
                        onClick={() => gotoProject(items.path)}
                        className={items.customClass}
                      >
                        {items.menu_icon}
                        <Translator id={items.menu_title} />
                      </MenuItem>
                      {items.needDownDivider && <Divider />}
                    </div>
                  );
                })}
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Popper>
    </div>
  );
}
